export const UPDATE_DEBUG_FLAGS = 'UPDATE_DEBUG_FLAGS';

export function updateDebugFlags(flags) {
  return { type: UPDATE_DEBUG_FLAGS, flags };
}
